import { render, staticRenderFns } from "./MessageInboxPopover.vue?vue&type=template&id=500bf737&scoped=true&"
import script from "./MessageInboxPopover.vue?vue&type=script&lang=ts&"
export * from "./MessageInboxPopover.vue?vue&type=script&lang=ts&"
import style0 from "./MessageInboxPopover.vue?vue&type=style&index=0&id=500bf737&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500bf737",
  null
  
)

export default component.exports